export default "__VITE_ASSET__DPAhCjJS__"